import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { propArrayShape } from '../../../../../../../helpers/custom-prop-types';
import ShareTableRowOpenTooltipRow from './ShareTableRowOpenTooltipRow';
const ShareTableRowOpenTooltip = (props) => {
    const { members } = props;
    return (_jsx("ul", { children: members.map((v) => (_jsx("li", { children: _jsx(ShareTableRowOpenTooltipRow, { member: v }) }, v.id))) }));
};
ShareTableRowOpenTooltip.propTypes = {
    members: propArrayShape().isRequired,
};
export default ShareTableRowOpenTooltip;
